import React from "react";

export default class EmailRenderer extends React.Component<any>
{
    render(): React.ReactNode
    {
        const email = this.props.value.toLowerCase();

        return <b><a href={`mailto:${email}`}>{email}</a></b>;
    }
}